<template>
  <transition name="fade" appear>
    <div class="login-container">
      <div class="logo-section">
        <img src="../assets/login-logo.png" alt="logo" class="logo" />
      </div>
      <div class="button-section">
        <button class="login-btn" @click="handleLogin">登录</button>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Start',
  mounted() {
    const token = localStorage.getItem('token');
    if (token) {
      this.$router.replace('/home');
    }
  },
  methods: {
    handleLogin() {
      this.$router.push('/login');
    }
  }
};
</script>

<style scoped>
.login-container {
  width: 100%;
  height: 100vh;
  background-color: #000;
  background-image: url('../assets/login-bg.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 80px 20px 40px;
}

.logo-section {
  flex: 1;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

.logo {
  max-width: 60%;
  height: auto;
}

.button-section {
  width: 100%;
}

.login-btn {
  width: 100%;
  height: 50px;
  background: linear-gradient(180deg, #36D8AF 0%, #10BDA7 100%);
  border: none;
  border-radius: 25px;
  color: #000;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.login-btn:active {
  opacity: 0.8;
}
</style>
